import { render, staticRenderFns } from "./lymphomap-header.html?vue&type=template&id=795c9df9&scoped=true&"
import script from "./lymphomap-header.js?vue&type=script&lang=js&"
export * from "./lymphomap-header.js?vue&type=script&lang=js&"
import style0 from "./lymphomap-header.scss?vue&type=style&index=0&id=795c9df9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "795c9df9",
  null
  
)

export default component.exports